class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.filterForm = this.querySelector('form');
    this.debouncedOnSubmit = this.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if (this.filterForm) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Handle form submit
    this.filterForm.addEventListener('submit', (event) => {
      event.preventDefault();
      this.onSubmitHandler();
    });
    
    // Handle checkbox changes - allow multiple selections
    const checkboxes = this.filterForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', () => {
        this.onSubmitHandler();
      });
    });
    
    // Handle price inputs with debounce
    const priceInputs = this.filterForm.querySelectorAll('input[type="number"]');
    priceInputs.forEach((input) => {
      input.addEventListener('input', () => {
        this.onSubmitHandler();
      });
    });
  }

  onSubmitHandler() {
    const formData = new FormData(this.filterForm);
    const searchParams = new URLSearchParams(formData).toString();
    
    this.renderPage(searchParams);
  }

  renderPage(searchParams) {
    const url = `${window.location.pathname}?${searchParams}`;
    
    // Update URL without reload
    window.history.pushState({}, '', url);
    
    // Show loading
    document.body.classList.add('filtering');
    
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        // Update products grid
        const newProductGrid = html.getElementById('CollectionProductGrid');
        const currentProductGrid = document.getElementById('CollectionProductGrid');
        if (newProductGrid && currentProductGrid) {
          currentProductGrid.innerHTML = newProductGrid.innerHTML;
        }
        
        // Update filters (to show active state and counts)
        const newFilters = html.getElementById('main-collection-filters');
        const currentFilters = document.getElementById('main-collection-filters');
        if (newFilters && currentFilters) {
          // Get the form element before replacing
          const formElement = currentFilters.querySelector('form');
          currentFilters.innerHTML = newFilters.innerHTML;
          
          // Reconnect event listeners after DOM update
          this.filterForm = this.querySelector('form');
          this.setupEventListeners();
        }
        
        // Update results count in toolbar
        const newToolbar = html.querySelector('.toolbar');
        const currentToolbar = document.querySelector('.toolbar');
        if (newToolbar && currentToolbar) {
          const newCount = newToolbar.querySelector('.results-count');
          const currentCount = currentToolbar.querySelector('.results-count');
          if (newCount && currentCount) {
            currentCount.innerHTML = newCount.innerHTML;
          }
        }
        
        document.body.classList.remove('filtering');
      })
      .catch(error => {
        console.error('Error filtering:', error);
        document.body.classList.remove('filtering');
      });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('collection-filters', CollectionFilters);

// Loading state styles
const style = document.createElement('style');
style.textContent = `
  body.filtering {
    cursor: wait;
  }
  
  body.filtering .collection-products {
    opacity: 0.5;
    pointer-events: none;
  }
`;
document.head.appendChild(style);
